export const OPEN_PROFILE_TEAM_SHARING_EVENT = "openProfileTeamSharing";

export const openProfileTeamSharingManager = () => {
  const event = new CustomEvent(OPEN_PROFILE_TEAM_SHARING_EVENT);
  window.dispatchEvent(event);
};
